export type InfoOrganizerAction =
  | { type: 'SET_IS_FETCHING_ORGANIZER_CONTENT' }
  | { type: 'SET_FETCH_ORGANIZER_CONTENT_FAILED' }
  | { type: 'SET_ORGANIZER_CONTENT', content: Julius.Website.OrganizerPageViewModel };

  export const setIsFetching = (): InfoOrganizerAction => ({
    type: 'SET_IS_FETCHING_ORGANIZER_CONTENT',
  });

  export const setFetchFailed = (): InfoOrganizerAction => ({
    type: 'SET_FETCH_ORGANIZER_CONTENT_FAILED',
  });

  export const setContent = (content: Julius.Website.OrganizerPageViewModel): InfoOrganizerAction => ({
    content,
    type: 'SET_ORGANIZER_CONTENT',
  });


// WEBPACK FOOTER //
// ./src/pages/InfoOrganizerPage/Redux/actions.tsx